export default __webpack_public_path__ + "static/media/Strangler's Leggings of the Hidden Tomb.e9a0996e.jpg";